// extracted by mini-css-extract-plugin
export default {"nav-links":"navbar_nav-links__EOd4t","nav-brand":"navbar_nav-brand__foaOr"};